import { useState, useRef } from 'react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { useToast } from "@/hooks/use-toast";
import emailjs from '@emailjs/browser';

// Configuración directa de EmailJS
const EMAILJS_SERVICE_ID = 'service_3wu7a6r';
const EMAILJS_TEMPLATE_ID = 'template_e14p4z5';
const EMAILJS_PUBLIC_KEY = 'Bi6If04QmAk2ieOQo';

interface ContactFormProps {
  translations: {
    name: string;
    email: string;
    message: string;
    send: string;
  };
}

const ContactForm = ({ translations }: ContactFormProps) => {
  const form = useRef<HTMLFormElement>(null);
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.current) return;

    setIsLoading(true);

    try {
      console.log('Attempting to send email...');
      
      const result = await emailjs.sendForm(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        form.current,
        EMAILJS_PUBLIC_KEY
      );

      console.log('Email sent successfully:', result);

      toast({
        title: "Message sent!",
        description: "We'll get back to you as soon as possible.",
      });

      // Limpiar el formulario
      form.current.reset();
    } catch (error) {
      console.error('Error sending email:', error);
      toast({
        title: "Error",
        description: "Something went wrong. Please try again.",
        variant: "destructive"
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form ref={form} onSubmit={handleSubmit} className="space-y-4">
      <div>
        <Input
          name="from_name"
          placeholder={translations.name}
          required
          disabled={isLoading}
        />
      </div>
      <div>
        <Input
          name="from_email"
          type="email"
          placeholder={translations.email}
          required
          disabled={isLoading}
        />
      </div>
      <div>
        <Textarea
          name="message"
          placeholder={translations.message}
          className="min-h-[150px]"
          required
          disabled={isLoading}
        />
      </div>
      <input 
        type="hidden" 
        name="sent_date" 
        value={new Date().toLocaleString()} 
      />
      <Button 
        type="submit" 
        className="w-full"
        disabled={isLoading}
      >
        {isLoading ? (
          <span className="animate-spin">⌛</span>
        ) : (
          translations.send
        )}
      </Button>
    </form>
  );
};

export default ContactForm; 